// import React from "react"
// import { useState } from "react"
// import { Link, useLocation, useNavigate } from "react-router-dom"
// import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Dropdown, Badge } from "react-bootstrap"
// import { FaHeart, FaBars, FaUser, FaSignOutAlt, FaShieldAlt } from "react-icons/fa"
// import { useAuth } from "../../context/AuthContext"

// export default function Navbar() {
//   const [expanded, setExpanded] = useState(false)
//   const location = useLocation()
//   const navigate = useNavigate()
//   const { user, isAuthenticated, logout, hasRole } = useAuth()

//   const isActive = (path) => location.pathname === path

//   const handleLogout = () => {
//     logout()
//     navigate("/")
//     setExpanded(false)
//   }

//   const getUserDashboardLink = () => {
//     if (hasRole('super_admin')) return '/admin/super-admin'
//     if (hasRole('admin')) return '/admin/dashboard'
//     if (hasRole('doctor')) return '/doctor/dashboard'
//     if (hasRole('patient')) return '/patient/dashboard'
//     return '/patient/login'
//   }

//   const getUserRoleLabel = () => {
//     if (hasRole('super_admin')) return 'Super Admin'
//     if (hasRole('admin')) return 'Administrator'
//     if (hasRole('doctor')) return 'Doctor'
//     if (hasRole('patient')) return 'Patient'
//     return 'Guest'
//   }

//   return (
//     <BootstrapNavbar
//       expand="lg"
//       className="bg-white shadow-sm sticky-top"
//       expanded={expanded}
//       onToggle={setExpanded}
//       style={{ backdropFilter: "blur(10px)", backgroundColor: "rgba(255, 255, 255, 0.95)" }}
//     >
//       <Container>
//         <BootstrapNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
//           <div
//             className="d-flex align-items-center justify-content-center rounded-circle me-3"
//             style={{
//               width: "45px",
//               height: "45px",
//               background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//               boxShadow: "0 4px 15px rgba(8, 145, 178, 0.3)",
//             }}
//           >
//             <FaHeart className="text-white" size={20} />
//           </div>
//           <div>
//             <span
//               className="fs-2"
//               style={{
//                 background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//                 backgroundClip: "text",
//                 fontWeight:"800"
//               }}
//             >
//               Aidify
//             </span>
//             <div className="small text-muted" style={{ fontSize: "0.75rem", marginTop: "-2px" }}>
//               Simply Satisfy
//             </div>
//           </div>
//         </BootstrapNavbar.Brand>

//         <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" className="border-0">
//           <FaBars />
//         </BootstrapNavbar.Toggle>

//         <BootstrapNavbar.Collapse id="basic-navbar-nav">
//           <Nav className="me-auto ms-4">
//             {[
//               { path: "/", label: "Home" },
//               { path: "/about", label: "About" },
//               { path: "/services", label: "Services" },
//               { path: "/faq", label: "FAQ" },
//               { path: "/contact", label: "Contact" },
//             ].map(({ path, label }) => (
//               <Nav.Link
//                 key={path}
//                 as={Link}
//                 to={path}
//                 className={`px-3 py-2 rounded-pill mx-1 fw-medium transition-all ${
//                   isActive(path) ? "text-white" : "text-dark hover-lift"
//                 }`}
//                 style={
//                   isActive(path)
//                     ? {
//                         background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                         boxShadow: "0 4px 15px rgba(8, 145, 178, 0.3)",
//                       }
//                     : {}
//                 }
//                 onClick={() => setExpanded(false)}
//               >
//                 {label}
//               </Nav.Link>
//             ))}


//           </Nav>

//           <div className="d-flex align-items-center">
//             {isAuthenticated() ? (
//               <Dropdown>
//                 <Dropdown.Toggle
//                   variant="link"
//                   className="text-decoration-none d-flex align-items-center px-3 py-2 rounded-pill"
//                   style={{
//                     background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                     color: "white",
//                     border: "none",
//                   }}
//                 >
//                   <div
//                     className="rounded-circle me-2 d-flex align-items-center justify-content-center"
//                     style={{
//                       width: "32px",
//                       height: "32px",
//                       background: "rgba(255, 255, 255, 0.2)",
//                     }}
//                   >
//                     <FaUser size={14} />
//                   </div>
//                   <span className="fw-medium">{user?.name || 'User'}</span>
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu className="border-0 rounded-4 shadow-lg" style={{ minWidth: "250px" }}>
//                   <div className="p-3 border-bottom">
//                     <div className="d-flex align-items-center">
//                       <div
//                         className="rounded-circle me-3 d-flex align-items-center justify-content-center"
//                         style={{
//                           width: "50px",
//                           height: "50px",
//                           background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                         }}
//                       >
//                         <FaUser className="text-white" size={20} />
//                       </div>
//                       <div>
//                         <div className="fw-bold">{user?.name || 'User'}</div>
//                         <div className="text-muted small">{user?.email}</div>
//                         <Badge bg="primary" className="rounded-pill mt-1">
//                           {getUserRoleLabel()}
//                         </Badge>
//                       </div>
//                     </div>
//                   </div>
                  
//                   <Dropdown.Item as={Link} to={getUserDashboardLink()} className="py-3 px-4">
//                     <div className="d-flex align-items-center">
//                       <FaShieldAlt className="me-3 text-primary" />
//                       <span>Dashboard</span>
//                     </div>
//                   </Dropdown.Item>
                  
//                   <Dropdown.Item as={Link} to="/profile" className="py-3 px-4">
//                     <div className="d-flex align-items-center">
//                       <FaUser className="me-3 text-primary" />
//                       <span>Profile</span>
//                     </div>
//                   </Dropdown.Item>
                  
//                   <Dropdown.Divider />
                  
//                   <Dropdown.Item onClick={handleLogout} className="py-3 px-4 text-danger">
//                     <div className="d-flex align-items-center">
//                       <FaSignOutAlt className="me-3" />
//                       <span>Logout</span>
//                     </div>
//                   </Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//             ) : (
//               <>
//                 <Link
//                   to="/patient/login"
//                   className="d-flex align-items-center px-4 py-2 rounded-pill me-3 text-decoration-none"
//                   style={{
//                     background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                     boxShadow: "0 4px 15px rgba(8, 145, 178, 0.3)",
//                     transition: "all 0.3s ease",
//                   }}
//                   onClick={() => setExpanded(false)}
//                 >
//                   <FaUser className="text-white me-2" />
//                   <span className="fw-bold text-white">Sign In</span>
//                 </Link>
//                 <Link
//                   to="/patient/register"
//                   className="d-flex align-items-center px-4 py-2 rounded-pill me-3 text-decoration-none"
//                   style={{
//                     background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
//                     boxShadow: "0 4px 15px rgba(5, 150, 105, 0.3)",
//                     transition: "all 0.3s ease",
//                   }}
//                   onClick={() => setExpanded(false)}
//                 >
//                   <FaUser className="text-white me-2" />
//                   <span className="fw-bold text-white">Sign Up</span>
//                 </Link>
//                 <div className="d-flex flex-column align-items-end">
//                   <Link
//                     to="/admin/login"
//                     className="text-muted text-decoration-none small"
//                     onClick={() => setExpanded(false)}
//                   >
//                     Admin Portal
//                   </Link>
//                   <Link
//                     to="/admin/super-admin/login"
//                     className="text-muted text-decoration-none small"
//                     onClick={() => setExpanded(false)}
//                   >
//                     Super Admin
//                   </Link>
//                 </div>
//               </>
//             )}
//           </div>
//         </BootstrapNavbar.Collapse>
//       </Container>

//       <style jsx>{`
//         .hover-lift:hover {
//           transform: translateY(-2px);
//           transition: all 0.3s ease;
//         }
        
//         .transition-all {
//           transition: all 0.3s ease;
//         }
//       `}</style>
//     </BootstrapNavbar>
//   )
// }


"use client"
import { useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Navbar as BootstrapNavbar, Nav, NavDropdown, Container, Dropdown, Badge } from "react-bootstrap"
import { FaHeart, FaPhone, FaBars, FaUser, FaUserShield, FaWhatsapp, FaSignOutAlt, FaShieldAlt } from "react-icons/fa"
import { useAuth } from "../../context/AuthContext"

export default function Navbar() {
  const [expanded, setExpanded] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const { user, isAuthenticated, logout, hasRole } = useAuth()

  // Check if user is in admin or patient portal
  const isInPortal = location.pathname.startsWith("/admin") || location.pathname.startsWith("/patient")

  const isActive = (path) => location.pathname === path

  const handleLogout = () => {
    logout()
    navigate("/")
    setExpanded(false)
  }

  const getUserDashboardLink = () => {
    if (hasRole("admin")) return "/admin/dashboard"
    if (hasRole("doctor")) return "/doctor/dashboard"
    if (hasRole("patient")) return "/patient/dashboard"
    return "/patient/login"
  }

  const getUserRoleLabel = () => {
    if (hasRole("admin")) return "Administrator"
    if (hasRole("doctor")) return "Doctor"
    if (hasRole("patient")) return "Patient"
    return "Guest"
  }

  const getPortalLabel = () => {
    if (location.pathname.startsWith("/admin")) return "Admin Portal"
    if (location.pathname.startsWith("/patient")) return "Patient Portal"
    return ""
  }

  return (
    <BootstrapNavbar
      expand="lg"
      className="shadow-sm sticky-top"
      expanded={expanded}
      onToggle={setExpanded}
      style={{
    background: "linear-gradient(299deg, #0C4754 25%, #ffffff 100%)",
            backdropFilter: "blur(10px)",
      }}
    >
      <Container>
        {/* <BootstrapNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle me-3"
            style={{
              width: "45px",
              height: "45px",
              background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              boxShadow: "0 4px 15px rgba(5, 150, 105, 0.3)",
            }}
          >
            <FaHeart className="text-white" size={20} />
          </div>
          <div>
            <span
              className="fs-2 text-white"
              style={{
                fontWeight: "800",
              }}
            >
              Aidify
            </span>
            <div className="small text-white opacity-75" style={{ fontSize: "0.75rem", marginTop: "-2px" }}>
              Your Health Partner
            </div>
          </div>
        </BootstrapNavbar.Brand>

        <BootstrapNavbar.Toggle
          aria-controls="basic-navbar-nav"
          className="border-0"
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <FaBars className="text-white" />
        </BootstrapNavbar.Toggle> */}
        <BootstrapNavbar.Brand as={Link} to="/" >
  <img
    src="/logo-aidify.png"
    alt="Aidify Logo"
    style={{
        height: "120px",      
      width: "auto",
      objectFit: "contain",
      marginTop: "-25px",   
      marginBottom: "-25px"
    }}
  />
</BootstrapNavbar.Brand>
   <BootstrapNavbar.Toggle
          aria-controls="basic-navbar-nav"
          className="border-0"
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <FaBars className="text-white" />
        </BootstrapNavbar.Toggle>


        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto ms-4">
            {!isInPortal ? (
              // Show navigation links only when not in portal
              <>
                {[
                  { path: "/", label: "Home" },
                  { path: "/about", label: "About" },
                  { path: "/services", label: "Services" },
                  { path: "/faq", label: "FAQ" },
                  { path: "/contact", label: "Contact" },
                ].map(({ path, label }) => (
                  <Nav.Link
                    key={path}
                    as={Link}
                    to={path}
                    className={`px-3 py-2 rounded-pill mx-1 fw-medium transition-all text-white ${
                      isActive(path) ? "active-nav-link" : "hover-lift"
                    }`}
                    style={
                      isActive(path)
                        ? {
                            background: "rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            boxShadow: "0 4px 15px rgba(255, 255, 255, 0.1)",
                          }
                        : {}
                    }
                    onClick={() => setExpanded(false)}
                  >
                    {label}
                  </Nav.Link>
                ))}

                {/* {!isAuthenticated() && (
                  <NavDropdown
                    title={<span className="fw-medium text-white">Portals</span>}
                    id="portals-dropdown"
                    className="mx-1"
                  >
                    <NavDropdown.Item
                      as={Link}
                      to="/patient/login"
                      onClick={() => setExpanded(false)}
                      className="py-3 px-4 border-0 rounded-3 mb-2"
                      style={{ transition: "all 0.3s ease" }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "40px",
                            height: "40px",
                            background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                            boxShadow: "0 4px 15px rgba(37, 99, 235, 0.3)",
                          }}
                        >
                          <FaUser className="text-white" size={16} />
                        </div>
                        <div>
                          <div className="fw-bold" style={{ color: "#0891b2" }}>
                            Patient Portal
                          </div>
                          <small className="text-muted">Access your medical records</small>
                        </div>
                      </div>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item
                      as={Link}
                      to="/admin/login"
                      onClick={() => setExpanded(false)}
                      className="py-3 px-4 border-0 rounded-3"
                      style={{ transition: "all 0.3s ease" }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: "40px",
                            height: "40px",
                            background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                            boxShadow: "0 4px 15px rgba(5, 150, 105, 0.3)",
                          }}
                        >
                          <FaUserShield className="text-white" size={16} />
                        </div>
                        <div>
                          <div className="fw-bold" style={{ color: "#059669" }}>
                            Admin Portal
                          </div>
                          <small className="text-muted">Manage patients and appointments</small>
                        </div>
                      </div>
                    </NavDropdown.Item>
                  </NavDropdown>
                )} */}
              </>
            ) : (
              // Show portal indicator when in portal
              <div className="d-flex align-items-center">
                <span className="fw-bold text-white fs-5" style={{ color: "#ffffff" }}>
                  {getPortalLabel()}
                </span>
              </div>
            )
            }
          </Nav>

          <div className="d-flex align-items-center">
            {isAuthenticated() ? (
              <Dropdown>
                <Dropdown.Toggle
                  variant="link"
                  className="text-decoration-none d-flex align-items-center px-3 py-2 rounded-pill"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    color: "white",
                  }}
                >
                  <div
                    className="rounded-circle me-2 d-flex align-items-center justify-content-center"
                    style={{
                      width: "32px",
                      height: "32px",
                      background: "rgba(255, 255, 255, 0.2)",
                    }}
                  >
                    <FaUser size={14} />
                  </div>
                  <span className="fw-medium">{user?.name || "User"}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="border-0 rounded-4 shadow-lg" style={{ minWidth: "250px" }}>
                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                        }}
                      >
                        <FaUser className="text-white" size={20} />
                      </div>
                      <div>
                        <div className="fw-bold">{user?.name || "User"}</div>
                        <div className="text-muted small">{user?.email}</div>
                        <Badge bg="primary" className="rounded-pill mt-1">
                          {getUserRoleLabel()}
                        </Badge>
                      </div>
                    </div>
                  </div>

                  <Dropdown.Item as={Link} to={getUserDashboardLink()} className="py-3 px-4">
                    <div className="d-flex align-items-center">
                      <FaShieldAlt className="me-3 text-primary" />
                      <span>Dashboard</span>
                    </div>
                  </Dropdown.Item>

                  <Dropdown.Item as={Link} to="/profile" className="py-3 px-4">
                    <div className="d-flex align-items-center">
                      <FaUser className="me-3 text-primary" />
                      <span>Profile</span>
                    </div>
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Item onClick={handleLogout} className="py-3 px-4 text-danger">
                    <div className="d-flex align-items-center">
                      <FaSignOutAlt className="me-3" />
                      <span>Logout</span>
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <>
                {/* <div
                  className="d-flex align-items-center px-4 py-2 rounded-pill me-3 hover-lift"
                  style={{
                    background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                    boxShadow: "0 4px 15px rgba(220, 38, 38, 0.3)",
                    animation: "pulse 2s infinite",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  <FaPhone className="text-white me-2" />
                  <span className="fw-bold text-white">Call Aidify</span>
                </div>
                <div
                  className="d-flex align-items-center px-4 py-2 rounded-pill me-3 hover-lift"
                  style={{
                    background: "linear-gradient(135deg, rgb(38, 220, 45) 0%, rgb(61, 185, 28) 100%)",
                    boxShadow: "0 4px 15px rgba(38, 220, 45, 0.3)",
                    animation: "pulse 2s infinite",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  <FaWhatsapp className="text-white me-2" />
                  <span className="fw-bold text-white">Text Aidify</span>
                </div> */}
              </>
            )}
          </div>
        </BootstrapNavbar.Collapse>
      </Container>

      <style jsx>{`
        .hover-lift:hover {
          transform: translateY(-2px);
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.1) !important;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .active-nav-link {
          background: rgba(255, 255, 255, 0.2) !important;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);
          }
          50% {
            box-shadow: 0 4px 25px rgba(220, 38, 38, 0.5);
          }
          100% {
            box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);
          }
        }
        
        .transition-all {
          transition: all 0.3s ease;
        }
      `}</style>
    </BootstrapNavbar>
  )
}
